<div fxFill fxLayout="row wrap" fxLayoutAlign="center center" class="mt-2">
    <div fxFlex="0 0 100%" class="mt-2">
        <h1 class="headline text-center" i18n="@@loggingIn">Logging in</h1>
    </div>
    <app-kd-logo-loading></app-kd-logo-loading>
</div>
